export const baseStylesheet = [
  {
    key: 'global',
    componentName: 'Global',
    selector: ':root,:host',
    rules: {
      '--color-primary': '#4392F1',
      '--color-secondary': '#59c3c3',
      '--color-tertiary': '#333745',
      '--color-danger': '#ee4266',
      '--color-success': '#b6c454',
      '--color-warning': '#fcad0d',
      '--color-neutral': '#333745',
      '--color-lines': '#d4d8e4',
      '--color-background': '#fafafa',
      '--text-font-family': 'Open Sans',
      '--text-font-size': '16px',
      '--text-font-weight': '100',
      '--text-line-height': 'initial',
    },
  },
  {
    key: 'checklist_item',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--item',
    rules: {
      '--background-color': '#ffffff',
      '--border-color': 'var(--checklist-item-border-color)',
      '--border-radius': '4px',
      '--border-style': 'solid',
      '--border-width': 'var(--checklist-item-border-width)',
      '--checklist-item-border-color': '#d4d8e4',
      '--checklist-item-border-width': '1px',
      '--color': 'var(--color-neutral)',
      '--font-family': 'var(--text-font-family)',
      '--font-size': 'var(--text-font-size)',
      '--font-weight': '600',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      'border-style': 'var(--border-style)',
      'border-radius': 'var(--border-radius)',
      'border-width': 'var(--border-width)',
      'checklist-item-border-color': 'var(--checklist-item-border-color)',
      'checklist-item-border-width': 'var(--checklist-item-border-width)',
      color: 'var(--color)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
      margin: 'var(--margin)',
      padding: 'var(--padding)',
      outline: 'none',
    },
  },
  {
    key: 'checklist_checkbox_base',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--checkbox',
    rules: {
      '--border-radius': '4px',
      '--border-width': '1px',
      '--border-style': 'solid',
      '--cursor': 'pointer',
      '--height': '32px',
      '--margin': '16px 16px 16px 16px',
      '--padding': '0px 0px 0px 0px',
      '--width': '32px',
      'border-radius': 'var(--border-radius)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      cursor: 'var(--cursor)',
      height: 'var(--height)',
      margin: 'var(--margin)',
      padding: 'var(--padding)',
      width: 'var(--width)',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      outline: 'none',
      transition: 'all .1s ease-out 0s',
    },
  },
  {
    key: 'checklist_checkbox_unchecked',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--checkbox-unchecked',
    rules: {
      '--background-color': '#f3f4f6',
      '--border-color': '#dde0e4',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'checklist_checkbox_unchecked_hover',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--checkbox-unchecked:hover',
    rules: {
      '--background-color': '#f3f4f6',
      '--border-color': '#7e86a0',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'checklist_checkbox_checked',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--checkbox-checked',
    rules: {
      '--background-color': '#cff5f5',
      '--border-color': '#a0e9e9',
      '--checkbox-checked-arrow-color': '#46aeae',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      'checkbox-checked-arrow-color': 'var(--checkbox-checked-arrow-color)',
    },
  },
  {
    key: 'checklist_checkbox_checked_hover',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--checkbox-checked:hover',
    rules: {
      '--background-color': '#cff5f5',
      '--border-color': '#46aeae',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'checklist_progress_bar_container',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--progress-bar-container',
    rules: {
      '--background-color': '#edeff3',
      '--height': '4px',
      '--margin': '0px 0px 16px 0px',
      '--width': '100%',
      'background-color': 'var(--background-color)',
      'border-radius': 'var(--border-radius)',
      height: 'var(--height)',
      margin: 'var(--margin)',
      width: 'var(--width)',
      overflow: 'hidden',
    },
  },
  {
    key: 'checklist_progress_bar',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--progress-bar',
    rules: {
      '--background-color': '#59c3c3',
      '--height': '100%',
      'background-color': 'var(--background-color)',
      height: 'var(--height)',
      transition: 'all .35s ease-out 0s',
    },
  },
  {
    key: 'checklist_group_title',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--group-title',
    rules: {
      '--color': 'var(--color-neutral)',
      '--font-family': 'var(--text-font-family)',
      '--font-size': '24px',
      '--font-weight': '100',
      '--margin': '0px 0px 16px 0px',
      color: 'var(--color)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
      margin: 'var(--margin)',
    },
  },
  {
    key: 'checklist_checkbox_disabled_hover',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--checkbox[disabled]:hover',
    rules: { '--cursor': 'default', cursor: 'var(--cursor)' },
  },
  {
    key: 'checklist_checkbox_unchecked_focus',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--checkbox-unchecked:focus',
    rules: {
      '--background-color': '#f3f4f6',
      '--border-color': '#7e86a0',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'checklist_checkbox_checked_focus',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--checkbox-checked:focus',
    rules: {
      '--background-color': '#cff5f5',
      '--border-color': '#46aeae',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'checklist_item_hover',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--item:hover',
    rules: { '--border-color': '#7e86a0', 'border-color': 'var(--border-color)' },
  },
  {
    key: 'checklist_item_focus',
    componentName: 'Checklist',
    selector: '.candu-checklist .candu-checklist--item:focus',
    rules: { '--border-color': '#7e86a0', 'border-color': 'var(--border-color)' },
  },
  {
    key: 'button_base',
    componentName: 'Button',
    selector: '.candu-button',
    rules: {
      '--background-color': 'buttonface',
      '--border-color': 'transparent',
      '--border-radius': 'initial',
      '--border-style': 'solid',
      '--border-width': 'initial',
      '--color': 'initial',
      '--cursor': 'pointer',
      '--font-family': 'var(--text-font-family)',
      '--font-size': '13.3px',
      '--font-weight': 'initial',
      '--height': 'initial',
      '--line-height': 'initial',
      '--padding': '8px 16px 8px 16px',
      '--margin': '0px 0px 0px 0px',
      '--text-decoration': 'none',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      'border-radius': 'var(--border-radius)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      color: 'var(--color)',
      cursor: 'var(--cursor)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
      height: 'var(--height)',
      'line-height': 'var(--line-height)',
      padding: 'var(--padding)',
      margin: 'var(--margin)',
      'text-decoration': 'var(--text-decoration)',
      'text-align': 'center',
      outline: 'none',
    },
  },
  {
    key: 'button_hover',
    componentName: 'Button',
    selector: '.candu-button:hover',
    rules: {
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      color: 'var(--color)',
      'font-weight': 'var(--font-weight)',
      'text-decoration': 'var(--text-decoration)',
    },
  },
  {
    key: 'button_focus',
    componentName: 'Button',
    selector: '.candu-button:focus',
    rules: {
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      color: 'var(--color)',
      'font-weight': 'var(--font-weight)',
      'text-decoration': 'var(--text-decoration)',
    },
  },
  {
    key: 'button_active',
    componentName: 'Button',
    selector: '.candu-button:active',
    rules: {
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      color: 'var(--color)',
      'font-weight': 'var(--font-weight)',
      'text-decoration': 'var(--text-decoration)',
    },
  },
  {
    key: 'typography_base',
    componentName: 'Typography',
    selector: '.candu-typography',
    rules: {
      '--color': 'var(--color-neutral)',
      '--font-family': 'var(--text-font-family)',
      '--font-size': 'var(--text-font-size)',
      '--font-style': 'normal',
      '--font-weight': '100',
      '--letter-spacing': '0px',
      '--line-height': 'initial',
      '--text-decoration': 'initial',
      color: 'var(--color)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-style': 'var(--font-style)',
      'font-weight': 'var(--font-weight)',
      'letter-spacing': 'var(--letter-spacing)',
      'line-height': 'var(--line-height)',
      'text-decoration': 'var(--text-decoration)',
    },
  },
  {
    key: 'link_base',
    componentName: 'Link',
    selector: '.candu-link',
    rules: {
      '--color': 'var(--color-primary)',
      '--cursor': 'pointer',
      '--font-family': 'var(--text-font-family)',
      '--font-size': 'initial',
      '--font-weight': 'bold',
      '--text-decoration': 'none',
      color: 'var(--color)',
      cursor: 'var(--cursor)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
      'text-decoration': 'var(--text-decoration)',
      outline: 'none',
    },
  },
  {
    key: 'link_hover',
    componentName: 'Link',
    selector: '.candu-link:hover',
    rules: { color: 'var(--color)', 'font-weight': 'var(--font-weight)' },
  },
  {
    key: 'link_focus',
    componentName: 'Link',
    selector: '.candu-link:focus',
    rules: { color: 'var(--color)', 'font-weight': 'var(--font-weight)' },
  },
  {
    key: 'link_visited',
    componentName: 'Link',
    selector: '.candu-link:visited',
    rules: { color: 'initial', 'font-weight': 'var(--font-weight)' },
  },
  {
    key: 'badge_base',
    componentName: 'Badge',
    selector: '.candu-badge',
    rules: {
      '--background-color': 'transparent',
      '--border-color': 'initial',
      '--border-radius': '4px',
      '--border-style': 'solid',
      '--border-width': '1px',
      '--color': 'initial',
      '--font-family': 'var(--text-font-family)',
      '--font-size': 'var(--text-font-size)',
      '--font-weight': 'initial',
      '--height': 'initial',
      '--line-height': 'initial',
      '--padding': '4px 16px 4px 16px',
      '--margin': '0px 0px 0px 0px',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      'border-radius': 'var(--border-radius)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      color: 'var(--color)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
      height: 'var(--height)',
      'line-height': 'var(--line-height)',
      padding: 'var(--padding)',
      margin: 'var(--margin)',
      'text-align': 'center',
      outline: 'none',
      display: 'inline-block',
    },
  },
  {
    key: 'form_base',
    componentName: 'Form',
    selector: '.candu-form',
    rules: {
      '--color': 'initial',
      '--font-family': 'var(--text-font-family)',
      '--font-size': 'var(--text-font-size)',
      '--font-weight': 'initial',
      color: 'var(--color)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
    },
  },
  {
    key: 'form_inputfield',
    componentName: 'Form',
    selector: '.candu-form .candu-form--input-field',
    rules: {
      '--background-color': 'transparent',
      '--border-color': 'initial',
      '--border-radius': '4px',
      '--border-style': 'solid',
      '--border-width': '1px',
      '--color': 'initial',
      '--font-family': 'var(--text-font-family)',
      '--font-size': 'var(--text-font-size)',
      '--font-weight': 'normal',
      '--height': '40px',
      '--margin': '0px 0px 6px 0px',
      '--padding': '0px 0px 0px 8px',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      'border-radius': 'var(--border-radius)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      color: 'var(--color)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
      height: 'var(--height)',
      margin: 'var(--margin)',
      padding: 'var(--padding)',
      outline: 'none',
    },
  },
  {
    key: 'form_inputfield_placeholder',
    componentName: 'Form',
    selector: '.candu-form .candu-form--input-field::placeholder',
    rules: { '--color': 'initial', color: 'var(--color)' },
  },
  {
    key: 'form_inputfield_textarea',
    componentName: 'Form',
    selector: '.candu-form textarea.candu-form--input-field',
    rules: {
      '--height': '97px',
      '--padding': '8px',
      height: 'var(--height)',
      padding: 'var(--padding)',
    },
  },
  {
    key: 'form_inputfield_hover',
    componentName: 'Form',
    selector: '.candu-form .candu-form--input-field:hover',
    rules: { 'background-color': 'var(--background-color)', 'border-color': 'var(--border-color)' },
  },
  {
    key: 'form_inputfield_focus',
    componentName: 'Form',
    selector: '.candu-form .candu-form--input-field:focus',
    rules: { 'background-color': 'var(--background-color)', 'border-color': 'var(--border-color)' },
  },
  {
    key: 'form_inputfield_error',
    componentName: 'Form',
    selector: '.candu-form .candu-form--input-field.error',
    rules: { 'border-color': 'var(--border-color)' },
  },
  {
    key: 'form_checkbox',
    componentName: 'Form',
    selector: '.candu-form .candu-form--checkbox',
    rules: {
      '--color': 'initial',
      '--font-weight': 'normal',
      '--font-family': 'var(--text-font-family)',
      '--font-size': 'var(--text-font-size)',
      '--margin': '0px 0px 6px 0px',
      '--padding': '0px 0px 0px 0px',
      color: 'var(--color)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
      margin: 'var(--margin)',
      padding: 'var(--padding)',
      outline: 'none',
    },
  },
  {
    key: 'form_checkbox_svg',
    componentName: 'Form',
    selector: '.candu-form svg.candu-form--checkbox',
    rules: { visibility: 'hidden' },
  },
  {
    key: 'form_checkboxdiv_selected_svg',
    componentName: 'Form',
    selector: '.candu-form .candu-form--checkbox input:checked ~ .candu-form--checkbox-div svg',
    rules: { outline: 'none', visibility: 'visible' },
  },
  {
    key: 'form_checkboxdiv',
    componentName: 'Form',
    selector: '.candu-form .candu-form--checkbox-div',
    rules: {
      '--active-background-color': '#FFF',
      '--checkbox-size': '11px',
      '--background-color': '#FFF',
      '--border-color': 'var(--color-lines)',
      '--border-radius': '4px',
      '--border-style': 'solid',
      '--border-width': '1px',
      '--height': '30px',
      '--margin': '0px 8px 0px 0',
      '--width': '30px',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      'border-radius': 'var(--border-radius)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      height: 'var(--height)',
      margin: 'var(--margin)',
      width: 'var(--width)',
      resize: 'none',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      outline: 'none',
    },
  },
  {
    key: 'form_checkboxdiv_selected',
    componentName: 'Form',
    selector: '.candu-form .candu-form--checkbox input:checked ~ .candu-form--checkbox-div',
    rules: {
      '--background-color': '#fff',
      '--checkbox-color-fill': '#59C3C3',
      'background-color': 'var(--background-color)',
      'checkbox-color-fill': 'var(--checkbox-color-fill)',
    },
  },
  {
    key: 'form_checkboxdiv_hover',
    componentName: 'Form',
    selector: '.candu-form .candu-form--checkbox-div:hover',
    rules: { 'background-color': 'var(--background-color)', 'border-color': 'var(--border-color)' },
  },
  {
    key: 'form_checkboxdiv_focus',
    componentName: 'Form',
    selector: '.candu-form .candu-form--checkbox-div:focus',
    rules: { 'background-color': 'var(--background-color)', 'border-color': 'var(--border-color)' },
  },
  {
    key: 'form_checkboxdiv_error',
    componentName: 'Form',
    selector: '.candu-form .candu-form--checkbox.error > .candu-form--checkbox-div',
    rules: { 'border-color': 'var(--border-color)' },
  },
  {
    key: 'form_mscard',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card',
    rules: {
      '--border-color': 'initial',
      '--background-color': 'transparent',
      '--border-radius': '4px',
      '--border-style': 'solid',
      '--border-width': '1px',
      '--margin': '0px 0px 0px 0px',
      '--padding': '0px 0px 0px 0px',
      'border-color': 'var(--border-color)',
      'background-color': 'var(--background-color)',
      'border-radius': 'var(--border-radius)',
      'border-width': 'var(--border-width)',
      margin: 'var(--margin)',
      padding: 'var(--padding)',
      outline: 'none',
      'border-style': 'var(--border-style)',
    },
  },
  {
    key: 'form_mscard_svg',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card > svg',
    rules: { visibility: 'hidden' },
  },
  {
    key: 'form_mscard_selected_svg',
    componentName: 'Form',
    selector:
      '.candu-form .candu-form--ms-card input:checked ~ .candu-form--ms-card-checkbox-div svg',
    rules: { visibility: 'visible' },
  },
  {
    key: 'form_mscard_checkboxdiv',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card-checkbox-div',
    rules: {
      '--active-background-color': '#fff',
      '--checkbox-size': '8px',
      '--background-color': '#fff',
      '--border-color': 'var(--color-lines)',
      '--border-radius': '4px',
      '--border-style': 'solid',
      '--border-width': '1px',
      '--height': '18px',
      '--margin': '0px 0px 0px 0',
      '--width': '18px',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      'border-radius': 'var(--border-radius)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      height: 'var(--height)',
      margin: 'var(--margin)',
      width: 'var(--width)',
      outline: 'none',
      resize: 'none',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
    },
  },
  {
    key: 'form_mscard_checkboxdiv_selected',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card input:checked ~ .candu-form--ms-card-checkbox-div',
    rules: {
      '--background-color': '#59C3C3',
      '--checkbox-color-fill': '#fff',
      'background-color': 'var(--background-color)',
      'checkbox-color-fill': 'var(--checkbox-color-fill)',
    },
  },
  {
    key: 'form_mscard_selected',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card:has(input:checked)',
    rules: {
      '--background-color': '#fff',
      '--border-color': '#59C3C3',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'form_mscard_checkboxdiv_hover',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card-checkbox-div:hover',
    rules: {
      '--background-color': '#fff',
      '--border-color': '#575E75',
      '--cursor': 'pointer',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      cursor: 'var(--cursor)',
    },
  },
  {
    key: 'form_mscard_checkboxdiv_focus',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card-checkbox-div:focus',
    rules: {
      '--background-color': '#fff',
      '--border-color': '#575E75',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'form_mscard_hover',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card:hover',
    rules: {
      '--background-color': '#fff',
      '--border-color': '#575E75',
      '--cursor': 'pointer',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      cursor: 'var(--cursor)',
    },
  },
  {
    key: 'form_mscard_focus',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card:focus',
    rules: {
      '--background-color': '#fff',
      '--border-color': '#575E75',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'form_mscard_checkboxdiv_error',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card.error > .candu-form--ms-card-checkbox-div',
    rules: { '--border-color': '#DB2B39', 'border-color': 'var(--border-color)' },
  },
  {
    key: 'form_mscard_error',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ms-card.error',
    rules: { '--border-color': '#DB2B39', 'border-color': 'var(--border-color)' },
  },
  {
    key: 'form_sscard',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ss-card',
    rules: {
      '--border-color': '#D2D6DB',
      '--background-color': 'transparent',
      '--border-radius': '4px',
      '--border-style': 'solid',
      '--border-width': '1px',
      '--margin': '0px 0px 0px 0px',
      '--padding': '0px 0px 0px 0px',
      'border-color': 'var(--border-color)',
      'background-color': 'var(--background-color)',
      'border-radius': 'var(--border-radius)',
      'border-width': 'var(--border-width)',
      margin: 'var(--margin)',
      padding: 'var(--padding)',
      outline: 'none',
      'border-style': 'var(--border-style)',
    },
  },
  {
    key: 'form_sscard_svg',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ss-card > svg',
    rules: { visibility: 'hidden' },
  },
  {
    key: 'form_sscard_selected',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ss-card:has(input:checked)',
    rules: {
      '--background-color': '#fff',
      '--border-color': '#59C3C3',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'form_sscard_hover',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ss-card:hover',
    rules: {
      '--background-color': '#fff',
      '--border-color': '#575E75',
      '--cursor': 'pointer',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      cursor: 'var(--cursor)',
    },
  },
  {
    key: 'form_sscard_focus',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ss-card:focus',
    rules: {
      '--background-color': '#fff',
      '--border-color': '#575E75',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'form_sscard_error',
    componentName: 'Form',
    selector: '.candu-form .candu-form--ss-card.error',
    rules: {
      '--background-color': '#fff',
      '--border-color': '#DB2B39',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
    },
  },
  {
    key: 'form_label',
    componentName: 'Form',
    selector: '.candu-form .candu-form--form-label',
    rules: {
      '--color': 'var(--color-neutral)',
      '--font-family': 'var(--text-font-family)',
      '--font-size': 'var(--text-font-size)',
      '--font-weight': 'normal',
      '--margin': '0px 0px 6px 0px',
      '--padding': '0px 0px 0px 0px',
      color: 'var(--color)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
      margin: 'var(--margin)',
      padding: 'var(--padding)',
    },
  },
  {
    key: 'form_label_error',
    componentName: 'Form',
    selector: '.candu-form .candu-form--form-label.error',
    rules: { '--color': '#DB2B39', color: 'var(--color)' },
  },
  {
    key: 'form_error_message',
    componentName: 'Form',
    selector: '.candu-form .candu-form--form-error-message',
    rules: {
      '--color': 'var(--color-danger)',
      '--font-family': 'var(--text-font-family)',
      '--font-size': '11px',
      '--font-weight': 'normal',
      '--text-align': 'initial',
      color: 'var(--color)',
      'font-family': 'var(--font-family)',
      'font-size': 'var(--font-size)',
      'font-weight': 'var(--font-weight)',
      'text-align': 'var(--text-align)',
    },
  },
  {
    key: 'card_base',
    componentName: 'Card',
    selector: '.candu-card',
    rules: {
      '--background-color': 'transparent',
      '--border-color': 'initial',
      '--border-radius': '0px',
      '--border-style': 'solid',
      '--border-width': '0px',
      '--box-shadow': '1px 1px 2px 1px #68718d14',
      '--cursor': 'pointer',
      '--padding': '24px 24px 24px 24px',
      '--margin': '0px 0px 0px 0px',
      '--card-stroke': '#565e61',
      '--card-stroke-width': '2px',
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      'border-style': 'var(--border-style)',
      'border-radius': 'var(--border-radius)',
      'border-width': 'var(--border-width)',
      'box-shadow': 'var(--box-shadow)',
      cursor: 'var(--cursor)',
      padding: 'var(--padding)',
      margin: 'var(--margin)',
      outline: 'none',
    },
  },
  {
    key: 'card_hover',
    componentName: 'Card',
    selector: '.candu-card:hover',
    rules: {
      'background-color': 'var(--background-color)',
      'border-color': 'var(--border-color)',
      'box-shadow': 'var(--box-shadow)',
    },
  },
  {
    key: 'card_dismiss',
    componentName: 'Card',
    selector: '.candu-card > .candu-dismiss-wrapper',
    rules: { '--padding': '8px 8px 8px 8px', padding: 'var(--padding)' },
  },
  {
    key: 'card_dismiss_svg',
    componentName: 'Card',
    selector: '.candu-card > .candu-dismiss-wrapper .candu-dismiss-svg',
    rules: { stroke: 'var(--card-stroke)', 'stroke-width': 'var(--card-stroke-width)' },
  },
  {
    key: 'modal_backdrop',
    componentName: 'Modal',
    selector: '.candu-modal .candu-modal--backdrop',
    rules: {
      position: 'fixed',
      inset: '0',
      'background-color': 'rgba(0, 0, 0, 0.5)',
      'z-index': 248,
    },
  },
  {
    key: 'modal_base',
    componentName: 'Modal',
    selector: '.candu-modal .candu-modal--container',
    rules: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      'z-index': 249,
      background: '#fff',
      'border-radius': '4px',
      width: '100%',
      'max-width': 'min(640px, calc(100% - 64px))',
      'max-height': 'calc(100% - 112px)',
      display: 'flex',
      'flex-direction': 'column',
      'overflow-y': 'auto',
      '--modal-dismiss-stroke': '#7e86a0',
      '--modal-dismiss-stroke-width': '2',
      'padding-left': '32px',
      'padding-right': '32px',
      'padding-bottom': '32px',
      'padding-top': '32px',
    },
  },
  {
    key: 'legacy_modal_base',
    componentName: 'Modal',
    selector: '.candu-legacyModal .candu-legacyModal--container',
    rules: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      'z-index': 249,
      background: '#fff',
      'border-radius': '4px',
      width: '100%',
      'max-width': 'min(640px, calc(100% - 64px))',
      'max-height': 'calc(100% - 112px)',
      display: 'flex',
      'flex-direction': 'column',
      'overflow-y': 'auto',
      '--modal-dismiss-stroke': '#7e86a0',
      '--modal-dismiss-stroke-width': '2',
      'padding-left': '32px',
      'padding-right': '32px',
      'padding-bottom': '32px',
      'padding-top': '32px',
    },
  },
  {
    key: 'legacy_modal_backdrop',
    componentName: 'Modal',
    selector: '.candu-legacyModal .candu-legacyModal--backdrop',
    rules: {
      position: 'fixed',
      inset: '0',
      'background-color': 'rgba(0, 0, 0, 0.5)',
      'z-index': 248,
    },
  },
  {
    key: 'modalV2_base',
    componentName: 'Modal',
    selector: '.candu-modalV2 .candu-modalV2--container',
    rules: {
      position: 'fixed',
      '--top': '50%',
      '--left': '50%',
      '--transform': 'translate(-50%,-50%)',
      '--width': '40%',
      '--min-width': 'initial',
      '--max-width': '100%',
      '--min-height': 'initial',
      '--max-height': 'initial',
      '--height': 'initial',
      '--border-radius': 'initial',
      '--background-color': '#fff',
      '--padding': 'initial',
      '--margin': 'initial',
      '--border-color': 'transparent',
      '--border-style': 'solid',
      '--border-width': 'initial',
      top: 'var(--top)',
      left: 'var(--left)',
      transform: 'var(--transform)',
      width: 'var(--width)',
      'min-width': 'var(--min-width)',
      'max-width': 'var(--max-width)',
      'min-height': 'var(--min-height)',
      'max-height': 'var(--max-height)',
      height: 'var(--height)',
      'border-radius': 'var(--border-radius)',
      'background-color': 'var(--background-color)',
      padding: 'var(--padding)',
      margin: 'var(--margin)',
      'border-color': 'var(--border-color)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      'box-sizing': 'border-box',
    },
  },
  {
    key: 'modalV2_backdrop',
    componentName: 'Modal',
    selector: '.candu-modalV2 .candu-modalV2--backdrop',
    rules: {
      '--background-color': 'rgba(0, 0, 0, 0.5)',
      position: 'fixed',
      inset: '0',
      'background-color': 'var(--background-color)',
    },
  },
  {
    key: 'modalV2_wrapper',
    componentName: 'Modal',
    selector: '.candu-modalV2',
    rules: { '--z-index': '5000', position: 'relative', 'z-index': 'var(--z-index)' },
  },
  {
    key: 'modalV2_dismiss',
    componentName: 'Modal',
    selector: '.candu-modalV2--container > .candu-dismiss-wrapper',
    rules: { '--padding': '8px 8px 8px 8px', padding: 'var(--padding)' },
  },
  {
    key: 'modalV2_dismiss_svg',
    componentName: 'Modal',
    selector: '.candu-modalV2--container > .candu-dismiss-wrapper .candu-dismiss-svg',
    rules: {
      '--modal-stroke': '#7e86a0',
      '--modal-stroke-width': '1',
      stroke: 'var(--modal-stroke)',
      'stroke-width': 'var(--modal-stroke-width)',
      'z-index': 2,
    },
  },
  {
    key: 'hotspot',
    componentName: 'Hotspot',
    selector: '.candu-hotspot',
    rules: {
      '--z-index': '4000',
      'max-width': '100%',
      'max-height': '100%',
      'box-sizing': 'border-box',
    },
  },
  {
    key: 'hotspot_beacon',
    componentName: 'Hotspot',
    selector: '.candu-h-beacon',
    rules: { position: 'absolute', 'z-index': 'var(--z-index)', outline: 'none' },
  },
  {
    key: 'hotspot_beacon_svg',
    componentName: 'Hotspot',
    selector: '.candu-h-beacon svg',
    rules: {
      '--beacon-color': '#6310E5',
      '--width': '32px',
      width: 'var(--width)',
      cursor: 'pointer',
    },
  },
  {
    key: 'hotspot_beacon_hover_svg_inner',
    componentName: 'Hotspot',
    selector: '.candu-h-beacon:hover .inner',
    rules: { transform: 'scale(1.6)' },
  },
  {
    key: 'hotspot_beacon_focus_visible_svg_inner',
    componentName: 'Hotspot',
    selector: '.candu-h-beacon:focus-visible .inner',
    rules: { transform: 'scale(1.6)' },
  },
  {
    key: 'hotspot_beacon_svg_inner',
    componentName: 'Hotspot',
    selector: '.candu-h-beacon svg .inner',
    rules: {
      transform: 'scale(1)',
      'transform-origin': 'center',
      transition: 'transform 0.75s ease',
      fill: 'var(--beacon-color)',
    },
  },
  {
    key: 'hotspot_beacon_svg_outer',
    componentName: 'Hotspot',
    selector: '.candu-h-beacon svg .outer',
    rules: { stroke: 'var(--beacon-color)' },
  },
  {
    key: 'hotspot_beacon_svg_animation',
    componentName: 'Hotspot',
    selector: '.candu-h-beacon svg .animation',
    rules: { stroke: 'var(--beacon-color)', opacity: 0, 'transform-origin': 'center' },
  },
  {
    key: 'hotspot_beacon_not_hover_svg_animation',
    componentName: 'Hotspot',
    selector: '.candu-h-beacon:not(:hover) svg .animation',
    rules: {
      'animation-name': 'hotspots-beacon-pulse',
      'animation-duration': '1.25s',
      'animation-iteration-count': 'infinite',
      'animation-timing-function': 'ease-out',
    },
  },
  {
    key: 'hotspot_tooltip_wrapper',
    componentName: 'Hotspot',
    selector: '.candu-h-wrapper',
    rules: {
      '--border-radius': '4px',
      '--background-color': '#FFFFFF',
      '--drop-shadow': '2px 2px 6px #68718d3d',
      position: 'fixed',
      'box-sizing': 'border-box',
      filter: 'drop-shadow(var(--drop-shadow))',
      'border-color': 'var(--border-color)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      'border-radius': 'var(--border-radius)',
      'background-color': 'var(--background-color)',
      'z-index': 'calc(var(--z-index) + 500)',
    },
  },
  {
    key: 'hotspot_tooltip_container',
    componentName: 'Hotspot',
    selector: '.candu-h-wrapper .candu-h-container',
    rules: {
      width: '100%',
      height: '100%',
      'background-color': 'inherit',
      'border-radius': 'inherit',
      'z-index': '0',
    },
  },
  {
    key: 'hotspot_tooltip_body',
    componentName: 'Hotspot',
    selector: '.candu-h-wrapper .candu-h-body',
    rules: { padding: 'var(--padding)', position: 'relative' },
  },
  {
    key: 'hotspot_tooltip_arrow',
    componentName: 'Hotspot',
    selector: '.candu-h-wrapper .candu-h-arrow',
    rules: {
      '--width': '20px',
      position: 'absolute',
      width: 'var(--width)',
      height: 'var(--width)',
      'background-color': 'inherit',
      border: 'inherit',
      transform: 'rotate(45deg)',
      'z-index': '-1',
    },
  },
  {
    key: 'hotspot_dismiss',
    componentName: 'Hotspot',
    selector: '.candu-h-wrapper .candu-h-container > .candu-dismiss-wrapper',
    rules: { padding: 'var(--padding)' },
  },
  {
    key: 'hotspot_dismiss_svg',
    componentName: 'Hotspot',
    selector: '.candu-h-wrapper .candu-h-container > .candu-dismiss-wrapper .candu-dismiss-svg',
    rules: {
      stroke: 'var(--hotspot-stroke)',
      'stroke-width': 'var(--hotspot-stroke-width)',
      'z-index': 2,
    },
  },
  {
    key: 'tour_step',
    componentName: 'TourStep',
    selector: '.candu-tour-step',
    rules: {
      '--z-index': '4000',
      'max-width': '100%',
      'max-height': '100%',
      'box-sizing': 'border-box',
    },
  },
  {
    key: 'tour_step_backdrop_wrapper',
    componentName: 'TourStep',
    selector: '.candu-t-backdrop-wrapper',
    rules: {
      '--background-color': '#00000040',
      position: 'fixed',
      'background-color': 'var(--background-color)',
      'z-index': 'calc(var(--z-index) + 500)',
    },
  },
  {
    key: 'tour_step_backdrop_container',
    componentName: 'TourStep',
    selector: '.candu-t-backdrop-container',
    rules: {
      '--border-style': 'solid',
      '--border-color': '#413EDF',
      '--border-width': '2px',
      '--border-radius': '0px',
      position: 'fixed',
      'border-color': 'var(--border-color)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      'border-radius': 'var(--border-radius)',
    },
  },
  {
    key: 'tour_step_tooltip_wrapper',
    componentName: 'TourStep',
    selector: '.candu-t-wrapper',
    rules: {
      '--border-radius': '4px',
      '--background-color': '#FFFFFF',
      '--drop-shadow': '2px 2px 6px #68718d3d',
      position: 'fixed',
      'box-sizing': 'border-box',
      filter: 'drop-shadow(var(--drop-shadow))',
      'border-color': 'var(--border-color)',
      'border-style': 'var(--border-style)',
      'border-width': 'var(--border-width)',
      'border-radius': 'var(--border-radius)',
      'background-color': 'var(--background-color)',
      'z-index': 'calc(var(--z-index) + 500)',
    },
  },
  {
    key: 'tour_dismiss',
    componentName: 'TourStep',
    selector: '.candu-t-wrapper .candu-t-container > .candu-dismiss-wrapper',
    rules: { padding: 'var(--padding)' },
  },
  {
    key: 'tour_dismiss_svg',
    componentName: 'TourStep',
    selector: '.candu-t-wrapper .candu-t-container > .candu-dismiss-wrapper .candu-dismiss-svg',
    rules: {
      stroke: 'var(--tour-stroke)',
      'stroke-width': 'var(--tour-stroke-width)',
      'z-index': 2,
    },
  },
  {
    key: 'tour_step_tooltip_container',
    componentName: 'TourStep',
    selector: '.candu-t-wrapper .candu-t-container',
    rules: {
      width: '100%',
      height: '100%',
      'background-color': 'inherit',
      'border-radius': 'inherit',
      position: 'relative',
      'z-index': '0',
    },
  },
  {
    key: 'tour_step_tooltip_body',
    componentName: 'TourStep',
    selector: '.candu-t-wrapper .candu-t-body',
    rules: { padding: 'var(--padding)' },
  },
  {
    key: 'tour_step_tooltip_arrow',
    componentName: 'TourStep',
    selector: '.candu-t-wrapper .candu-t-arrow',
    rules: {
      '--width': '20px',
      border: 'inherit',
      position: 'absolute',
      width: 'var(--width)',
      height: 'var(--width)',
      'background-color': 'inherit',
      transform: 'rotate(45deg)',
      'z-index': '-1',
    },
  },
  {
    key: 'candu_portal',
    componentName: 'EmbedPortal',
    selector: '.candu-portal',
    rules: { width: '100%' },
  },
];
